import axios from "axios";

const api = axios.create({
  baseURL: "https://foco-api.herokuapp.com"
});

export default api;
